<template>
      <div class="page-inner">
        <breadcrumb title="Input Travel Request"></breadcrumb>
        <div class="page-section">
          <form id="form" action="#" autocomplete="off">
            <!-- grid row -->
            <div class="row">
              <!-- grid column -->
              <div class="col-lg-12">
                <!-- .card -->
                <div class="card card-fluid">
                  <!-- .card-body -->
                  <div class="card-body">
                    <legend>Travel Data</legend>
                    <div class="form-row">
                      <label class="col-md-3">Employee</label>
                      <div class="col-md-6 mb-3">
                         {{emp_name}}
                      </div>
                    </div>
                    <div class="form-row" v-if="id!==null">
                      <label class="col-md-3">Transaction Number</label>
                      <div class="col-md-6 mb-3">
                        {{input_data.number}}
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Request Date</label>
                      <div class="col-md-6 mb-3">
                        <flat-pickr v-model="input_data.date" :config="config"  ></flat-pickr>
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Travel Partner</label>
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control"  placeholder="Travel Partner" v-model="input_data.partner">
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Travel Purpose</label>
                      <div class="col-md-6 mb-3">
                        <v-select :options="option_purpose" v-model="input_data.purpose" :reduce="data=>data.id" label="name"></v-select>
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Travel Activities or Summary</label>
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" placeholder="Travel Activities or Summary" v-model="input_data.activities">
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Activity Days</label>
                      <div class="col-md-5 mb-3">
                        <flat-pickr v-model="input_data.activity_days" :config="config_active_days"  ></flat-pickr>
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Payment Method</label>
                      <div class="col-md-5 mb-3">
                        <v-select :options="option_payment_method" v-model="input_data.payment_method" :reduce="data=>data.id" label="name"></v-select>
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Total Travel Expense</label>
                      <div class="col-md-5 mb-3">
                        <currency-input v-model="input_data.expense_amount" :modelValue="input_data.expense_amount" :options="option_currency_input"  @keyup="calcTotal" @change="calcTotal"></currency-input>
                      </div>
                      <div class="col-md-1 mb-2">
                          <v-select :options="option_currency" v-model="input_data.currency" :reduce="data=>data.id" label="code"></v-select>
                      </div>
                    </div>

                    <hr>
                    <legend>Itenary</legend>

                    <div class="form-group">
                      <label class="control-label">Ticket / Car Order</label>
                      <div class="table-responsive">
                        <button type="button" class="btn btn-success btn-sm" @click="addTicket" data-title="Add">
                          <em class="fa fa-plus mr-1"></em>Add</button>
                        <table class="table table-hover table-striped" aria-label="Ticket">
                          <thead>
                          <tr>
                            <th id="no">#</th>
                            <th style="width:150px" id="date">Date</th>
                            <th style="width:150px" id="transport-with">Transport With</th>
                            <th style="width:150px" id="from">From</th>
                            <th style="width:150px" id="to">To</th>
                            <th style="width:150px" id="departure">Departure</th>
                            <th style="width:150px" id="arrival">Arrival</th>
                            <th style="width:150px" id="paid-by">Paid By</th>
                            <th style="width:150px" id="amount">Amount</th>
                          </tr>
                          </thead>
                          <tbody id="tickets-body">
                            <tr v-for="(ticket, i) in tickets" v-bind:key="i">
                              <td><button type="button" class='btn btn-reset' @click="deleteTicket(i)"> <em class='fa fa-trash mr-1'></em></button></td>
                              <td><flat-pickr :config="config" v-model="ticket.date" ></flat-pickr></td>
                              <td><input type='text' class='form-control w-130'  v-model="ticket.carrier"></td>
                              <td><input type='text' class='form-control w-130'  v-model="ticket.depart"></td>
                              <td><input type='text' class='form-control w-130'  v-model="ticket.arrive"></td>
                              <td><flat-pickr :config="config_hours" v-model="ticket.etd"></flat-pickr></td>
                              <td><flat-pickr :config="config_hours" v-model="ticket.eta"></flat-pickr></td>
                              <td><b-form-select @change="calcTicket" v-model="ticket.paid_by" :options="option_paid_by"></b-form-select></td>
                              <td>
                                <currency-input :model-value="ticket.amount" v-model="ticket.amount" :options="option_currency_input"  @input="calcTicket"></currency-input>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                          <tr>
                            <th id="total_ticket" colspan="8" class="text-center">Total</th>
                            <td>
                              <currency-input :model-value="total_ticket" v-model="total_ticket" :options="option_currency_input" readonly="" />
                            </td>
                          </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="control-label">Hotel Order</label>
                      <div class="table-responsive">
                        <button type="button" class="btn btn-success btn-sm hotels-add" @click="addHotel()" data-title="Add">
                          <em class="fa fa-plus mr-1"></em>Add</button>
                        <table class="table table-hover table-striped" aria-label="Hotel">
                          <thead>
                          <tr>
                            <th id="no-hotel">#</th>
                            <th style="width:201px;" id="check-in">Check-in</th>
                            <th style="width:201px;" id="check-out">Check-out</th>
                            <th style="width:201px;" id="accommodation">Accommodation</th>
                            <th style="width:201px;" id="remark">Remark</th>
                            <th style="width:201px;" id="paid-by-hotel">Paid By</th>
                            <th style="width:201px;" id="amount-hotel">Amount</th>
                          </tr>
                          </thead>
                          <tbody >

                            <template  v-for="(hotel, i) in hotels">
                              <tr v-bind:key="i">
                                <td><button type="button" class='btn btn-reset' @click="deleteHotel(i)"> <em class='fa fa-trash mr-1'></em></button></td>
                                <td><flat-pickr :config="config" v-model="hotel.check_in" ></flat-pickr></td>
                                <td><flat-pickr :config="config" v-model="hotel.check_out"></flat-pickr></td>
                                <td><input type='text' class='form-control w-130'  v-model="hotel.accommodation"></td>
                                <td><input type='text' class='form-control w-130'  v-model="hotel.remarks"></td>
                                <td> <b-form-select @change="calcHotel" v-model="hotel.paid_by" :options="option_paid_by"></b-form-select></td>
                                <td>
                                  <currency-input :model-value="hotel.amount" v-model="hotel.amount" :options="option_currency_input" @keyup="calcHotel" @input="calcHotel"></currency-input>
                                </td>
                              </tr>
                            </template>

                          </tbody>
                          <tfoot>
                          <tr>
                            <th id="total_hotel" colspan="6" class="text-center">Total</th>
                            <td>
                              <currency-input :model-value="total_hotel" v-model="total_hotel" :options="option_currency_input" ></currency-input>
                            </td>
                          </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="form-row">
                      <label class="col-md-3">Travel cost paid by Admin</label>
                      <div class="col-md-3 mb-3">
                        <currency-input :model-value="paid_admin_amount" v-model="paid_admin_amount" :options="option_currency_input" readonly=""></currency-input>
                      </div>
                    </div>

                    <div class="form-row">
                      <label class="col-md-3">Cash Advance Amount</label>
                      <div class="col-md-3 mb-3">
                        <currency-input :model-value="cash_advance_amount" v-model="cash_advance_amount" :options="option_currency_input" readonly=""></currency-input>
                      </div>
                    </div>
                    <hr>
                    <template v-if="!this.$store.getters.companySettings.is_taf_auto_approve">
                      <legend>Approval</legend>

                      <list-supervisor module="travel"></list-supervisor>
                      <hr>
                    </template>
                    <div class="form-actions">
                      <button type="button" class="btn btn-primary ml-auto btn-save" @click="stat_id=1;submitData()">Submit</button>
                      <button type="button" class="btn btn-warning" @click="stat_id=0;submitData()">Save as Draft</button>
                      <button class="btn btn-secondary" data-title="Back" @click="backTo">Back</button>
                    </div>

                  </div><!-- /.card-body -->
                </div><!-- /.card -->
              </div><!-- /grid column -->
            </div><!-- /grid row -->
          </form>
        </div>
      </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import { BFormSelect} from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import vSelect from "vue-select";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "@/components/pages/employee/ListSupervisor";
import CurrencyInput from "@/components/CurrencyInput";

export default {
  name: "TravelRequestInput",
  components:{
    CurrencyInput,
    ListSupervisor,
    Breadcrumb,
    BFormSelect,
    flatPickr,
    vSelect,
  },
  data(){
    return {
      id:null,
      emp_name:"",
      emp_id:"",
      stat_id:0,
      input_data:{
        date:'',
        partner:'',
        activity_days:'',
        purpose:"",
        activities:"",
        payment_method:"",
        currency:"",
        expense_amount:9000
      },
      config: {
        //wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
      config_active_days: {
        //wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        mode:'range',
        locale: {
          rangeSeparator: ' - '
        },
      },
      config_hours: {
        //wrap: true, // set wrap to true only when using 'input-group'
        altInput: true,
        altFormat:"H:i",
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
      option_payment_method:[],
      option_purpose:[],
      total_ticket:0,
      total_ticket_by_admin:0,
      total_hotel:0,
      total_hotel_by_admin:0,
      tickets:[],
      tickets_deleted:[],
      hotels:[],
      hotels_deleted:[],
      option_paid_by:[{text:"Admin",  value:"admin"}, {text:"Personal", value: "personal"}],
      paid_admin_amount:0,
      cash_advance_amount:0,
      option_currency:[],
      option_currency_input : {
        currency: 'IDR',
        locale:'id-ID',
        currencyDisplay: 'hidden',
        valueRange: {min: 0,max: 999999999999},
        precision: 2,
        hideCurrencySymbolOnFocus: true,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: true,
        autoDecimalDigits: false,
        exportValueAsInteger: false,
        autoSign: true,
        useGrouping: true
      }
    }
  },
  methods:{
    calcTotal(){
      let paid_admin_amount = parseInt(this.total_hotel_by_admin) + parseInt(this.total_ticket_by_admin)
      this.paid_admin_amount = paid_admin_amount
      // console.log(this.total_hotel_by_admin, this.total_ticket_by_admin)
      this.cash_advance_amount = this.input_data.expense_amount - this.paid_admin_amount

    },
    calcHotel(){
      this.total_hotel = 0
      this.total_hotel_by_admin = 0
      for (let data of this.hotels){
        if (data.amount !== "" || data.amount !== null) {
          this.total_hotel += parseInt(data.amount)
          if (data.paid_by !== undefined){
            if (data.paid_by === "admin") {
              this.total_hotel_by_admin += parseInt(data.amount)
            }
          }
        }
      }
      this.calcTotal()
    },
    calcTicket(){
      this.total_ticket = 0
      this.total_ticket_by_admin = 0
      for (let data of this.tickets){

        if (data.amount !== ""){
          this.total_ticket += parseInt(data.amount)
          if (data.paid_by !== undefined){
            if (data.paid_by === "admin" ) {
              this.total_ticket_by_admin += parseInt(data.amount)
            }
          }
        }
      }
      this.calcTotal()
    },
    addHotel(){
      this.hotels.push({paid_by:"admin"})
    },
    addTicket(){
      this.tickets.push({paid_by:"admin"})
    },
    deleteHotel(index){
      this.hotels_deleted.push(this.hotels[index])
      this.hotels.splice(index, 1)
      this.calcHotel()
    },
    deleteTicket(index){
      this.tickets_deleted.push(this.tickets[index])
      this.tickets.splice(index, 1)
      this.calcTicket()
    },
    submitData(){
      let actDays = this.input_data.activity_days.split(" - ")
      let start = actDays[0]
      let end = (actDays[1] !== undefined? actDays[1]:actDays[0])
      let userProfile = this.$store.getters.userProfile.data.attributes
      let payload = {
        number:this.input_data.number,
        user_id:this.$store.getters.userId,
        unit_id: userProfile.emp_unit_id,
        date:this.input_data.date,
        partner:this.input_data.partner,
        start:start,
        end:end,
        curr_id:this.input_data.currency,
        payment_method:this.input_data.payment_method,
        expense_amount: this.input_data.expense_amount,
        purpose:this.input_data.purpose,
        activities:this.input_data.activities,
        paid_amount:this.paid_admin_amount,
        cash_advance_amount:this.cash_advance_amount,
        stat_id:this.stat_id,
        tickets:(this.tickets == null ? []: this.tickets),
        hotels:(this.hotels == null ? [] : this.hotels),
      }

      if(this.id !== null){
        payload.id=this.id
        payload.tickets_deleted = this.tickets_deleted
        payload.hotels_deleted = this.hotels_deleted
        AxiosCall.Put(payload, urlApi.travel_request.update).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$router.replace({name:"TravelRequest"})
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.travel_request.add).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$router.push({name:"TravelRequest"})
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    getCurrency(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.currency.list).then(res=>{
        if(res.success){
          this.option_currency = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    getPaymentMethod(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.reference.payment_method).then(res=>{
        if(res.success){
          this.option_payment_method = res.atributes
        }
      }).catch(e=>{
          this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getPurpose(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.reference.purpose).then(res=>{
        if(res.success){
          this.option_purpose = res.atributes
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    backTo(){
      this.$router.push({name:"TravelRequest"})
    },
    timeDiff (date1, date2) {
      var a = new Date(date1).getTime(),
          b = new Date(date2).getTime(),
          diff = {};

      diff.milliseconds = a > b ? a % b : b % a;
      diff.seconds = diff.milliseconds / 1000;
      diff.minutes = diff.seconds / 60;
      diff.hours = diff.minutes / 60;
      diff.days = diff.hours / 24;
      diff.weeks = diff.days / 7;

      return diff;
    },
    getDetail(){
      let payload = {id:this.id}
      AxiosCall.Get(payload, urlApi.travel_request.detail).then(res=>{
        if(res.success){
          this.emp_id = res.atributes.emp_id
          this.input_data = {
            date:res.atributes.date,
            number:res.atributes.number,
            partner:res.atributes.partner,
            purpose:res.atributes.purpose_id,
            activities: res.atributes.activities,
            activity_days:res.atributes.activity_start + ' - '+res.atributes.activity_end,
            payment_method:res.atributes.travel_paymethod_id,
            currency:res.atributes.curr_id,
            expense_amount: res.atributes.travel_expense_amount
          }

          this.tickets = []
          this.tickets = res.atributes.tickets !== null ? JSON.parse(res.atributes.tickets) : []
          this.hotels = []
          this.hotels = res.atributes.hotels !== null ? JSON.parse(res.atributes.hotels) : []
          this.calcHotel()
          this.calcTicket()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    numberWithCommas(x) {
      if(x !== undefined) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")+",00";
    },
  },
  beforeCreate() {
    if(this.$route.query.id){
      let payload = {id:this.$route.query.id }

      this.tickets = []
      this.hotels = []
      AxiosCall.Get(payload, urlApi.travel_request.detail).then(res=>{
        if(res.success){
          if(res.atributes.hotels !== null){
            let hotels = JSON.parse(res.atributes.hotels)
            for(let i=0; i < hotels.length; i++){
              this.hotels.push({amount:0})
            }
          }

          if(res.atributes.tickets !== null){
            let tickets = JSON.parse(res.atributes.tickets)
            for(let i=0; i < tickets.length; i++){
              this.tickets.push({amount:0})
            }
          }
        }

      }).catch(()=>{})
    }

  },
  beforeDestroy() {
    this.tickets = []
    this.hotels = []
  },
  mounted() {
    console.log(this.id)
    if (this.id !== null) {
      this.getDetail();
    }
  },
  created() {
    let userProfile = this.$store.getters.userProfile.data.attributes
    this.emp_name = userProfile.emp_name
    this.id = (this.$route.query.id !== undefined ? this.$route.query.id : null )
    this.emp_id =  userProfile.emp_id

    this.getCurrency()
    this.getPaymentMethod()
    this.getPurpose()
  }
}
</script>